import { ResourceActivity, ResourceActivityResourceType, ResourceVersionListItem } from '@/types';

import { apiClient } from '../http';

export type InboxStatus = 'all' | 'read' | 'unread';

export type InboxListParams = {
    cursor?: string;
    limit?: number;
    resourceType?: ResourceActivityResourceType;
    status?: InboxStatus;
};

export type InboxItem = {
    id: string;
    activity: ResourceActivity;
    kind: 'resource_activity';
    occurredAt: string;
    resourceId: string;
    resourceType: ResourceActivityResourceType;
    status: 'read' | 'unread';
    subscription?: {
        id: string;
        lastReadAt?: string;
        resourceId: string;
        resourceType: ResourceActivityResourceType;
        subscribed: boolean;
    };
    url?: string;
};

export type InboxPage = {
    items: InboxItem[];
    nextCursor?: string;
    hasMore: boolean;
    total: number;
};

export type InboxItemSnapshot =
    | {
          available: true;
          version: ResourceVersionListItem;
      }
    | {
          available: false;
          reason: 'uncaptured' | 'unsupported';
      };

export const inboxService = {
    list: (params?: InboxListParams) => apiClient.get<InboxPage, InboxListParams>('/api/inbox', { params }),
    getItemSnapshot: (activityId: string) => apiClient.get<InboxItemSnapshot>(`/api/inbox/${activityId}/snapshot`),
    markItemRead: (activityId: string) => apiClient.put<{ ok: boolean }>(`/api/inbox/${activityId}/read`),
    deleteItem: (activityId: string) =>
        apiClient.delete<{ ok: boolean; wasUnread: boolean }>(`/api/inbox/${activityId}`),
    markRead: () => apiClient.put<{ ok: boolean; readAt: string }>('/api/inbox/read'),
};
